import api from './api';

interface VersionResponse {
  version?: string | null;
  chatbot_name?: string | null;
}

export interface AppMetadata {
  version: string | null;
  chatbotName: string;
}

export const appMetaService = {
  async getMetadata(): Promise<AppMetadata> {
    const response = await api.get<VersionResponse>('/meta/version');
    const version = response.data?.version?.trim();
    const chatbotName = response.data?.chatbot_name?.trim() || 'Sara';

    return {
      version: !version || version === 'unknown' ? null : version,
      chatbotName,
    };
  },

  async getVersion(): Promise<string | null> {
    const metadata = await appMetaService.getMetadata();
    return metadata.version;
  },
};
